import { Set } from "immutable";

// Calculates the correct dimensions for all images in imageData
// that do not already have that value set, and then calls the
// callback function with the updated data
export default (imageData, callback) => {
  let finalData = imageData;
  let queue = Set();

  // Find any images that do not have a width or height set
  // and add them to our queue
  imageData.forEach((d, url) => {
    if (!d.width || !d.height) {
      queue = queue.add(url);
    }
  });

  // If there is nothing in the queue (i.e. all images already have their dimensions set)
  // Then just call the callback straight away and be done with it.
  if (queue.size === 0) {
    callback(finalData);
    return;
  }

  // Create a callback for the image load that will update our imageData with dimensions
  // and call the callback when the last set come in
  const setDimensions = (url, width, height) => {
    finalData = finalData.update(url, d => d.merge({ width, height }));
    queue = queue.delete(url);
    if (queue.size === 0) {
      callback(finalData);
    }
  };

  // Now finally, go through the queue and schedule us to get the image data back
  queue.forEach(url => {
    const d = imageData.get(url);
    let i = new Image();
    i.onload = () => setDimensions(url, i.width, i.height);
    i.src = `data:image/${d.type};base64,${d.data}`;
  });
};
